import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const Index = () => import(/* webpackChunkName: 'Index' */ '@/views/index/index');
const NotFound = () => import(/* webpackChunkName: 'Index' */ '@/views/404');
const statement = () => import(/* webpackChunkName: 'Index' */ '@/views/statement');
// const jstatement = () => import(/* webpackChunkName: 'Index' */ '@/views/judgmentStatement');
const Formation = () => import(/* webpackChunkName: 'Formation' */ '@/views/formation/formation');
const ZT3vs = () => import(/* webpackChunkName: 'Formation' */ '@/views/industry/zt3vs');
const ZT16v = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt16v');
// const ZT21v = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt21v');
const ZT39v = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt39v');
const ZT415M = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt415m');
const ZTX405 = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/ztx405');
const ZT11V = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt11v');
const ZT015X = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt015x');
const ZT30v = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt30v');
const ZT25v = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt25v');
const ZT25vData = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/zt25vData');
const Admin = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/admin');
const Simulation = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/simulation');
const Situation = () => import(/* webpackChunkName: 'industry' */ '@/views/industry/situation');
const Oil = () => import(/* webpackChunkName: 'solutions' */ '@/views/solutions/oil');
const Eletricity = () => import(/* webpackChunkName: 'solutions' */ '@/views/solutions/eletricity');
const Water = () => import(/* webpackChunkName: 'solutions' */ '@/views/solutions/water');
const Forestry = () => import(/* webpackChunkName: 'solutions' */ '@/views/solutions/forestry');
const Admiralty = () => import(/* webpackChunkName: 'solutions' */ '@/views/solutions/admiralty');
const Recycle = () => import(/* webpackChunkName: 'solutions' */ '@/views/solutions/recycle');
const Official = () => import(/* webpackChunkName: 'news' */ '@/views/news/official');
const Report = () => import(/* webpackChunkName: 'news' */ '@/views/news/report');
const Case = () => import(/* webpackChunkName: 'news' */ '@/views/case/list');
const Polaris = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/polaris'); // 已下线
const Pod = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/pod'); // 已下线
const Digital = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/digital'); // 已下线
// const Visual = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/visual'); // 已下线
// const PTZ = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/PTZ'); // 已下线
const About = () => import(/* webpackChunkName: 'about' */ '@/views/about/index');
const Company = () => import(/* webpackChunkName: 'about' */ '@/views/about/company');
const Contact = () => import(/* webpackChunkName: 'about' */ '@/views/about/contact');
const After = () => import(/* webpackChunkName: 'about' */ '@/views/about/after');
const Join = () => import(/* webpackChunkName: 'join' */ '@/views/join/index');
const Campus = () => import(/* webpackChunkName: 'join' */ '@/views/join/campus');
const Social = () => import(/* webpackChunkName: 'join' */ '@/views/join/social');

const Pilot = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/pilot'); // ZT-Pilot⻜控系统
const Link = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/link'); // ZT-Pilot⻜控系统
const Gimbal = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/gimbal'); // ZT-Pilot⻜控系统
const GimbalSpecial = () => import(/* webpackChunkName: 'avionics' */ '@/views/avionics/gimbalSpecial'); // ZT-Pilot⻜控系统

//亿飞解禁飞区页面
const noflyApply = () => import(/* webpackChunkName: 'avionics' */ '@/views/yf/noflyApply');
 const noflyLogin = () => import(/* webpackChunkName: 'avionics' */ '@/views/yf/noflyLogin');
 const noflyExamineList = () => import(/* webpackChunkName: 'avionics' */ '@/views/yf/noflyExamineList');
 const noflyExamine = () => import(/* webpackChunkName: 'avionics' */ '@/views/yf/noflyExamine');
// const noflyApply = () => import(/* webpackChunkName: 'avionics' */ '@/views/yf/noflyApply');

export default new Router({
  mode: 'history',
  routes: [
    //解禁飞区 亿飞
    {
      path: '/noflyApply',
      name: 'noflyApply',
      component: noflyApply
    },
    {
      path: '/noflyLogin',
      name: 'noflyLogin',
      component: noflyLogin
    },
    {
      path: '/noflyExamineList',
      name: 'noflyExamineList',
      component: noflyExamineList
    },
    {
      path: '/noflyExamine',
      name: 'noflyExamine',
      component: noflyExamine
    },
    //
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/oil',
      name: 'oil',
      component: Oil
    },
    {
      path: '/eletricity',
      name: 'eletricity',
      component: Eletricity
    },
    {
      path: '/water',
      name: 'water',
      component: Water
    },
    {
      path: '/forestry',
      name: 'forestry',
      component: Forestry
    },
    {
      path: '/admiralty',
      name: 'admiralty',
      component: Admiralty
    },
    {
      path: '/recycle',
      name: 'recycle',
      component: Recycle
    },
    {
      path: '/news/official',
      name: 'official',
      component: Official
    },
    {
      path: '/statement',
      name: 'statement',
      component: statement
    },
    // {
    //   path: '/jstatement',
    //   name: 'jstatement',
    //   component: jstatement
    // },
    {
      path: '/news/report',
      name: 'report',
      component: Report
    },
    {
      path: '/case/list',
      name: 'caseList',
      component: Case
    },
    {
      path: '/zt3vs',
      name: 'zt3vs',
      component: ZT3vs
    },
    {
      path: '/zt16v',
      name: 'zt16v',
      component: ZT16v
    },
    // {
    //   path: '/zt21v',
    //   name: 'zt21v',
    //   component: ZT21v
    // },
    {
      path: '/zt39v',
      name: 'zt39v',
      component: ZT39v
    },
    {
      path: '/zt415m',
      name: 'zt415m',
      component: ZT415M
    },
    {
      path: '/ztx405',
      name: 'ztx405',
      component: ZTX405
    },
    {
      path: '/zt11v',
      name: 'zt11v',
      component: ZT11V
    },
    {
      path: '/zt015x',
      name: 'zt015x',
      component: ZT015X
    },
    {
      path: '/zt30v',
      name: 'zt30v',
      component: ZT30v
    },
    {
      path: '/zt25v',
      name: 'zt25v',
      component: ZT25v
    },
    {
      path: '/zt25v-data',
      name: 'zt25vData',
      component: ZT25vData
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '/simulation',
      name: 'simulation',
      component: Simulation
    },
    {
      path: '/situation',
      name: 'situation',
      component: Situation
    },
    {
      path: '/polaris',
      name: 'polaris',
      component: Polaris
    },
    {
      path: '/pod',
      name: 'pod',
      component: Pod
    },
    {
      path: '/digital',
      name: 'digital',
      component: Digital
    },
    // {
    //   path: '/visual',
    //   name: 'visual',
    //   component: Visual
    // },
    // {
    //   path: '/PTZ',
    //   name: 'PTZ',
    //   component: PTZ
    // },
    {
      path: '/formation',
      name: 'formation',
      component: Formation
    },
    {
      path: '/pilot',
      name: 'Pilot',
      component: Pilot
    },
    {
      path: '/link',
      name: 'Link',
      component: Link
    },
    {
      path: '/gimbal',
      name: 'Gimbal',
      component: Gimbal
    },
    {
      path: '/gimbal-special',
      name: 'GimbalSpecial',
      component: GimbalSpecial
    },
    {
      path: '/about-us',
      name: 'aboutUs',
      component: About
    },
    {
      path: '/company',
      name: 'company',
      component: Company
    },
    {
      path: '/contact-us',
      name: 'contactUs',
      component: Contact
    },
    {
      path: '/after-sale',
      name: 'afterSales',
      component: After
    },
    {
      path: '/join-us',
      name: 'joinUs',
      component: Join
    },
    {
      path: '/campus',
      name: 'campus',
      component: Campus
    },
    {
      path: '/social',
      name: 'social',
      component: Social
    },
    {
      path: '/not-found',
      name: 'notFound',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/not-found'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js